export const categories = [
  {
    id: "entertainment",
    name: "娱乐八卦",
    description: "最新明星动态和圈内秘闻，第一时间吃瓜不迷路。",
    icon: "ri-fire-line",
    subCategories: ["明星", "影视", "综艺"],
  },
  {
    id: "society",
    name: "社会新闻",
    description: "聚焦民生百态与社会热点，看见真实的世界。",
    icon: "ri-earth-line",
    subCategories: ["社会热点", "民生", "法治"],
  },
  {
    id: "star",
    name: "明星动态",
    description: "追踪明星行程、作品与生活，掌握第一手动态。",
    icon: "ri-star-line",
    subCategories: ["影视", "音乐", "综艺"],
  },
  {
    id: "hot",
    name: "热点事件",
    description: "全网热议事件深度解析，看清来龙去脉。",
    icon: "ri-flashlight-line",
    subCategories: ["网络热议", "文旅", "消费"],
  },
];